import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface BrandLogoProps {
    className?: string
    compact?: boolean
}

const BrandMark: FC<{ className?: string }> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 40 40' className={className} aria-hidden='true'>
            <rect x='1.5' y='1.5' width='37' height='37' rx='8' fill='#ffe14d' stroke='#141210' strokeWidth='3' />
            <path d='M14 6.5v27M26 6.5v27M6.5 14h27M6.5 26h27' stroke='#141210' strokeWidth='2' />
            <rect x='14' y='14' width='12' height='12' fill='#8cefaa' stroke='#141210' strokeWidth='2' />
            <circle cx='20' cy='20' r='2.4' fill='#141210' />
            <path d='M20 3.5l2.2 3.4h-4.4z' fill='#e0383e' />
        </svg>
    )
}

const BrandLogo: FC<BrandLogoProps> = ({ className, compact = false }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <BrandMark className='size-9 shrink-0' />

            {!compact && (
                <span className='flex flex-col leading-none'>
                    <span className='text-[17px] font-black tracking-tight'>
                        GeoVastu
                    </span>

                    <span className='font-mono text-[10px] font-bold uppercase tracking-[0.18em] text-muted-foreground'>
                        Gyan Kosh
                    </span>
                </span>
            )}
        </span>
    )
}

export default BrandLogo
